import "../Stylesheet/Skill.css";
import { FiCode, FiFigma, FiUsers, FiMessageCircle, FiClock } from "react-icons/fi";
import { IoCodeSlash } from "react-icons/io5";
import { GrNode } from "react-icons/gr";
import { TbBrandTypescript } from "react-icons/tb";
import { RiTailwindCssFill } from "react-icons/ri";
import { FaReact } from "react-icons/fa";
import { FaGithub } from "react-icons/fa6";
import { MdOutlineColorLens } from "react-icons/md";
import { useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";

export default function Skill() {

  const { t ,lang } = useContext(LanguageContext);
  const s = t.skills;

  return (
    <section className="skills-section">
      {/* Header */}
      <div className="skills-header">
        <h2 className={lang === "ta" ? "h2-ta" : "h2-en"}>{s.title}</h2>
        <p>{s.subtitle}</p>
      </div>

      {/* Content */}
      <div className="skills-content">
        {/* Technical Skills */}
        <div className="skills-column">

          <div className="column-title">
            <IoCodeSlash className="blue" />
            <h3>{s.technical.title}</h3>
          </div>

          <SkillItem icon={<FaReact />} text={s.technical.items[0]} />
          <SkillItem icon={<TbBrandTypescript />} text={s.technical.items[1]} />
          <SkillItem icon={<RiTailwindCssFill />} text={s.technical.items[2]} />
          <SkillItem icon={<GrNode />} text={s.technical.items[3]} />
        </div>

        {/* Tools & Software */}
        <div className="skills-column">
          <div className="column-title">
            <MdOutlineColorLens className="purple" />
            <h3>{s.tools.title}</h3>
          </div>

          <SkillItem2 icon={<FiFigma />} text={s.tools.items[0]} />
          <SkillItem2 icon={<FaGithub />} text={s.tools.items[1]} />
          <SkillItem2 icon={<FiCode />} text={s.tools.items[2]} />
          <SkillItem2 icon={<MdOutlineColorLens />} text={s.tools.items[3]} />

        </div>

        {/* Soft Skills */}
        <div className="skills-column">
          <div className="column-title">
            <FiUsers className="green" />
            <h3>{s.soft.title}</h3>
          </div>

          <SkillItem3 icon={<FiMessageCircle />} text={s.soft.items[0]} />
          <SkillItem3 icon={<FiUsers />} text={s.soft.items[1]} />
          <SkillItem3 icon={<FiClock />} text={s.soft.items[2]} />
        </div>
      </div>
    </section>
  );
}

/* Reusable Item */
function SkillItem({ icon, text }) {
  return (
    <div className="skill-item">
      <div className="skill-icon col">{icon}</div>
      <span>{text}</span>
    </div>
  );
}

/* Reusable Item */
function SkillItem2({ icon, text }) {
  return (
    <div className="skill-item">
      <div className="skill-icon col2">{icon}</div>
      <span>{text}</span>
    </div>
  );
}

/* Reusable Item */
function SkillItem3({ icon, text }) {
  return (
    <div className="skill-item">
      <div className="skill-icon col3">{icon}</div>
      <span>{text}</span>
    </div>
  );
}
